import React, { useContext } from 'react';
import ReactDOM from 'react-dom/client';
import { MemoryRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { ShlLinkContext } from './Contexts';
import { getInitialEntries } from './routing/sectionUrl';
import ShlLinkProvider from './routing/ShlLinkProvider';
import { getLegacyShlinkRedirectUrl } from './utils/shlUrlUtil';

const legacyRedirectUrl = getLegacyShlinkRedirectUrl(window.location);

if (legacyRedirectUrl) {
  window.location.replace(legacyRedirectUrl);
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <ShlLinkProvider>
        <ViewerRouter />
      </ShlLinkProvider>
    </React.StrictMode>,
  );
}

/**
 * Provides the in-memory route state scoped to the current SHL.
 * @returns {import('react').FunctionComponent} The viewer router.
 */
function ViewerRouter() {
  const shl = useContext(ShlLinkContext);

  return (
    <MemoryRouter key={shl || 'no-shl'} initialEntries={getInitialEntries()}>
      <App />
    </MemoryRouter>
  );
}
